import {
  get,
  post,
  download
} from "../utils/http";

const user = {
  // login: params => post('/user/login',params),
  login: params => post('/user/loginNew',params),
  changePassword: params => post('/user/changePassword',params),
  getCode: params => post('/user/verifyCode',params),
  getcustomer: params => get('/user/customer',params),
  page: params => post('/user/page',params),
  register: params => post('/user/register',params),
  editUser: params => post('/user/editUser',params),
  changePassword: params => post('/user/changePassword',params),
  deleteUser: params => post('/user/delete',params),
 



}

export default user;


// WEBPACK FOOTER //
// ./src/api/user.js